import { API_ENDPOINT } from '../services/api';
import branding from '../../config/branding';

interface StrapiErrorResult {
  error?: boolean | { message?: string; details?: { errors?: Array<{ message?: string }> } };
  data?: Array<{ messages?: Array<{ message?: string }>; message?: string }>;
  message?: string | Array<{ messages?: Array<{ message?: string }> }>;
  [key: string]: unknown;
}

interface StrapiItem {
  id: number;
  attributes?: Record<string, unknown>;
  [key: string]: unknown;
}

interface StrapiListResult {
  data?: StrapiItem[];
  [key: string]: unknown;
}

export const exposeStrapiError = (result: StrapiErrorResult | null | undefined) => {
  if (!result) {
    console.log('Cant connect to server, try again later');
    return true;
  }

  if (
    result?.error &&
    Array.isArray(result?.data) &&
    (result?.data as Array<{ messages?: Array<{ message?: string }> }>)?.[0]?.messages?.[0]
      ?.message &&
    typeof (result?.data as Array<{ messages?: Array<{ message?: string }> }>)?.[0]?.messages?.[0]
      ?.message === 'string'
  ) {
    console.log(
      (result?.data as Array<{ messages?: Array<{ message?: string }> }>)?.[0]?.messages?.[0]
        ?.message,
    );
    return true;
  } else if (
    result?.error &&
    Array.isArray(result?.message) &&
    (result?.message as Array<{ messages?: Array<{ message?: string }> }>)?.[0]?.messages?.[0]
      ?.message &&
    typeof (result?.message as Array<{ messages?: Array<{ message?: string }> }>)?.[0]
      ?.messages?.[0]?.message === 'string'
  ) {
    console.log(
      (result?.message as Array<{ messages?: Array<{ message?: string }> }>)?.[0]?.messages?.[0]
        ?.message,
    );
    return true;
  } else if (
    result?.error &&
    Array.isArray(result?.data) &&
    (result?.data as Array<{ message?: string }>)?.[0]?.message &&
    typeof (result?.data as Array<{ message?: string }>)?.[0]?.message === 'string'
  ) {
    console.log((result?.data as Array<{ message?: string }>)?.[0]?.message);
    return true;
  } else if (result?.error && result?.message && typeof result?.message === 'string') {
    console.log(result?.message);
    return true;
  } else if (
    result?.error &&
    typeof result?.error === 'object' &&
    (result?.error as { message?: string })?.message &&
    typeof (result?.error as { message?: string })?.message === 'string'
  ) {
    console.log((result?.error as { message?: string })?.message);
    return true;
  }

  if (
    result?.error &&
    typeof result?.error === 'object' &&
    (result?.error as { details?: { errors?: Array<{ message?: string }> } })?.details?.errors
      ?.length
  ) {
    (result?.error as { details?: { errors?: Array<{ message?: string }> } })?.details?.errors?.map(
      (item: { message?: string }) => {
        console.log(item?.message);
      },
    );
    return true;
  }

  return false;
};

export const parseStrapiImage = (url: string | null | undefined) => {
  return url
    ? url?.indexOf('://') !== -1
      ? url
      : url?.indexOf(branding.cdnDomain) !== -1
        ? `https://${url}`
        : `${API_ENDPOINT.replace(/\/api$/, '')}${url}`
    : '';
};

export const normalizeStrapiList = (result: StrapiListResult) => {
  return result?.data?.length
    ? result?.data.map((item: StrapiItem) => ({
        id: item.id,
        ...item.attributes,
      }))
    : result;
};

export const normalizeStrapiRegisterSolo = (result: Record<string, unknown>) => {
  return result?.id && result?.attributes
    ? {
        id: result?.id,
        ...(result?.attributes as Record<string, unknown>),
      }
    : (result?.data as Record<string, unknown>)?.id
      ? (result?.data as Record<string, unknown>)?.attributes
        ? {
            id: (result?.data as Record<string, unknown>)?.id,
            ...((result?.data as Record<string, unknown>)?.attributes as Record<string, unknown>),
          }
        : result?.data
      : result;
};

export const normalizeStrapiRegister = (result: Record<string, unknown>) => {
  const results = normalizeStrapiRegisterSolo(result) as Record<string, unknown>;
  Object.keys(results).map((attrKey) => {
    const val = results[attrKey] as Record<string, unknown> | undefined;
    results[attrKey] = val?.data ? normalizeStrapiRegisterSolo(val) : results[attrKey];
    const updated = results[attrKey] as Record<string, unknown> | undefined;
    results[attrKey] = typeof updated?.data === 'object' ? updated?.data : results[attrKey];
    const arr = results[attrKey] as Array<Record<string, unknown>> | undefined;
    results[attrKey] =
      arr?.length && (arr?.[0] as Record<string, unknown>)?.attributes
        ? arr?.map(normalizeStrapiRegisterSolo)
        : results[attrKey];
  });
  return results;
};
